import { useId } from "react";
import type { ConfirmDialogProps, ConfirmTone } from "./ConfirmDialog.types";

const TONE_COLOR = { default: "primary", warning: "warning", error: "error" } as const satisfies Record<
	ConfirmTone,
	string
>;

export function useConfirmDialogViewModel(props: ConfirmDialogProps) {
	const bodyId = useId();
	const tone = props.tone ?? "default";
	return {
		bodyId,
		describedBy: props.body == null ? undefined : bodyId,
		confirmColor: TONE_COLOR[tone],
		// A destructive confirm opens on Cancel, so Enter cannot destroy anything.
		initialFocus: tone === "error" ? ("cancel" as const) : ("primary" as const),
	};
}
